import {combineEpics} from 'web-app/util/redux-observable';
import {type Action} from 'web-app/util/redux/action-types';
import {type RootState} from 'signin-app/redux/main-reducer';

import employeeCheckIn from './check-in/epics';
import employeeCheckOut from './check-out/epics';

export default combineEpics<Action<any>, Action<any>, RootState>(employeeCheckIn, employeeCheckOut);
